export interface IGenerateDeliverySlips {
  orderId: number;
  deliveryMethod: string;
  shopProviderKey: string;
  operationId: string;
}
